export default __webpack_public_path__ + "static/media/Background_00191.6745508e.png";